module.exports = __webpack_public_path__ + "static/media/Cats eyes 06_SPANSKA-mixdown.8d72ccbf.mp3";